module.exports = __webpack_public_path__ + "img/logo-footer.704f0bf.svg";